export default __webpack_public_path__ + "static/media/4682.44ff6bd2.png";